import { Button } from '../../components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../components/ui/dialog';
import { AlertTriangle } from 'lucide-react';

export function DrugAlertsDialog({ open, onOpenChange, drugAlerts, onRemoveLastItem }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-amber-700">
            <AlertTriangle className="w-5 h-5" />
            Drug Interaction Alert
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <p className="text-sm text-slate-600">
            The following potential drug interactions have been detected in the current prescription:
          </p>
          <div className="space-y-2">
            {drugAlerts.map(function(alert, idx) {
              const severityColors = {
                high: 'bg-red-50 border-red-200 text-red-800',
                moderate: 'bg-amber-50 border-amber-200 text-amber-800',
                low: 'bg-blue-50 border-blue-200 text-blue-800'
              };
              return (
                <div key={idx} className={'p-3 rounded-lg border ' + (severityColors[alert.severity] || severityColors.moderate)}>
                  <div className="flex items-center justify-between mb-1">
                    <span className="font-medium text-sm">{alert.medicine1} - {alert.medicine2}</span>
                    <span className={'text-xs px-2 py-0.5 rounded ' + (alert.severity === 'high' ? 'bg-red-200' : alert.severity === 'moderate' ? 'bg-amber-200' : 'bg-blue-200')}>
                      {alert.severity.toUpperCase()}
                    </span>
                  </div>
                  <p className="text-xs">{alert.effect}</p>
                </div>
              );
            })}
          </div>
          <div className="pt-2 border-t">
            <p className="text-xs text-slate-500 mb-3">
              Please consult with a pharmacist or physician before proceeding with this prescription.
            </p>
            <div className="flex gap-2">
              <Button
                variant="outline"
                className="flex-1"
                onClick={function() { onOpenChange(false); }}
              >
                Acknowledge & Continue
              </Button>
              <Button
                className="flex-1 bg-red-600 hover:bg-red-700"
                onClick={onRemoveLastItem}
              >
                Remove Item
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
